const PLANS = {
  free: 'free',
  premium: 'premium'
}

const SUBSCRIPTION_STATUS = {
  inactive: 'inactive',
  active: 'active',
  trialing: 'trialing',
  paymentFailed: 'payment_failed'
}

module.exports = {
  PLANS,
  SUBSCRIPTION_STATUS
}
